"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("../Link"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

// Main class export
class Copyright extends _react.default.Component {
  createLink(link) {
    if (!link.href) {
      return /*#__PURE__*/_react.default.createElement("span", null, link.text);
    }
    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: link.href,
      style: {
        color: '#777',
        textDecoration: 'none',
        letterSpacing: '1.2px',
        transition: 'all 0.2s ease-in-out'
      },
      hoverStyles: {
        color: '#00a9f2'
      }
    }, link.text);
  }
  renderLinks() {
    return this.props.links.map((link, i) => {
      return /*#__PURE__*/_react.default.createElement("span", {
        key: i
      }, /*#__PURE__*/_react.default.createElement("span", null, " | "), this.createLink(link));
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "copyright-section",
      style: {
        fontSize: '12px',
        color: '#777',
        fontWeight: '100',
        marginBottom: '32px'
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, this.props.text && this.props.text.replace('@{year}', new Date().getFullYear())), this.renderLinks(), " | ", /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'inline'
      },
      id: "teconsent"
    }));
  }
}
exports.default = Copyright;
;
Copyright.propTypes = {
  text: _propTypes.default.string,
  links: _propTypes.default.array
};
Copyright.defaultProps = {
  links: []
};